/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CentralSystemResponse } from "./CentralSystemResponse";
import {
    CentralSystemResponseFromJSON,
    CentralSystemResponseFromJSONTyped,
    CentralSystemResponseToJSON,
} from "./CentralSystemResponse";

/**
 *
 * @export
 * @interface CentralSystemsResponse
 */
export interface CentralSystemsResponse {
    /**
     *
     * @type {Array<CentralSystemResponse>}
     * @memberof CentralSystemsResponse
     */
    centralSystems?: Array<CentralSystemResponse>;
}

/**
 * Check if a given object implements the CentralSystemsResponse interface.
 */
export function instanceOfCentralSystemsResponse(
    value: object,
): value is CentralSystemsResponse {
    return true;
}

export function CentralSystemsResponseFromJSON(
    json: any,
): CentralSystemsResponse {
    return CentralSystemsResponseFromJSONTyped(json, false);
}

export function CentralSystemsResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CentralSystemsResponse {
    if (json == null) {
        return json;
    }
    return {
        centralSystems:
            json["centralSystems"] == null
                ? undefined
                : (json["centralSystems"] as Array<any>).map(
                      CentralSystemResponseFromJSON,
                  ),
    };
}

export function CentralSystemsResponseToJSON(
    value?: CentralSystemsResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        centralSystems:
            value["centralSystems"] == null
                ? undefined
                : (value["centralSystems"] as Array<any>).map(
                      CentralSystemResponseToJSON,
                  ),
    };
}
